module.exports = __webpack_public_path__ + "static/media/exit.fe8f62f7.svg";